module.exports = __webpack_public_path__ + "static/media/practicascomerciales.f6fcb7ae.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/practicascomerciales.pdf
// module id = 776
// module chunks = 0